import type {TypeFilterValue} from '../../../../modules/calendar-filter';
import type {ID, Nullable} from '../../../../utils/utility-types';
import type {BaseNavigationService} from '../base/BaseNavigation.service';

export abstract class AppNavigationService {
  abstract baseNavigation: BaseNavigationService;
  abstract goToEvent: (config: AppNavigationService.GoToEvent) => void;
  abstract goToTodos: (config: AppNavigationService.GoToTodos) => void;
}

export namespace AppNavigationService {
  export type GoToEvent = {
    id: string;
  };

  export type GoToTodos = {
    courseId?: Nullable<ID>;
    type?: TypeFilterValue;
  };
}
